import {Serializers} from '../../interfaces/serializer';
import {GeneralDimension} from '../../interfaces/dimensions';
import {DimensionComponentObjects} from '../../classes/dimension-component-object';

export const GENERAL_DIMENSIONS_STATE_NAME = 'generalDimensions';

export interface GeneralDimensionsState {
  serialized: Serializers<GeneralDimension>;
  componentObjects: DimensionComponentObjects;
  loading: boolean;
  loaded: boolean;
}
